import React from 'react';
import { BaseInputProps, SmartTagsTextInputWithLoad } from 'ui-builder';
import { useSmartTagsService } from 'nekst-api';

interface EventPlanTaskTitleInputProps extends BaseInputProps {
  planId: number,
}

export function EventPlanTaskTitleInput(props: EventPlanTaskTitleInputProps) {
  const smartTagsService = useSmartTagsService();

  return (
    <SmartTagsTextInputWithLoad
      getTagsMethod={async () => {
        return smartTagsService.getSmartTagsByPlanId(props.planId);
      }}
      dependencies={[props.planId]}
      label={props.label}
      source="name"
    />
  );
}
